/* eslint-disable @typescript-eslint/no-namespace, @typescript-eslint/array-type, @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types, @typescript-eslint/consistent-indexed-object-style, @typescript-eslint/no-redundant-type-constituents */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import type * as Types from './types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AlertRecipientSettingModelFieldsFragment = { __typename?: 'AlertRecipientSettingModel', user_id?: string | null, account_id?: string | null, email_enabled: boolean, email_status?: string | null, email_destination?: string | null, sms_enabled: boolean, sms_status?: string | null, sms_destination?: string | null };

export type ListAlertRecipientSettingsQueryVariables = Types.Exact<{
  input: Types.ListAlertRecipientSettingsInput;
}>;


export type ListAlertRecipientSettingsQuery = { __typename?: 'Query', listAlertRecipientSettings: Array<{ __typename?: 'AlertRecipientSettingModel', user_id?: string | null, account_id?: string | null, user?: { __typename?: 'UserModel', user_id: string, first_name: string, last_name: string } | null, account?: { __typename?: 'AccountModel', account_id: string, account_name?: string | null } | null }> };

export type GetAlertRecipientSettingQueryVariables = Types.Exact<{
  input: Types.GetAlertRecipientSettingInput;
}>;


export type GetAlertRecipientSettingQuery = { __typename?: 'Query', getAlertRecipientSetting: { __typename?: 'AlertRecipientSettingModel', user_id?: string | null, account_id?: string | null, email_enabled: boolean, email_status?: string | null, email_destination?: string | null, sms_enabled: boolean, sms_status?: string | null, sms_destination?: string | null } };

export type UpdateAlertRecipientSettingMutationVariables = Types.Exact<{
  input: Types.UpdateAlertRecipientSettingInput;
}>;


export type UpdateAlertRecipientSettingMutation = { __typename?: 'Mutation', updateAlertRecipientSetting: { __typename?: 'AlertRecipientSettingModel', user_id?: string | null, account_id?: string | null, email_enabled: boolean, email_status?: string | null, email_destination?: string | null, sms_enabled: boolean, sms_status?: string | null, sms_destination?: string | null } };

export type SendAlertCodeMutationVariables = Types.Exact<{
  input: Types.SendAlertSettingCodeInput;
}>;


export type SendAlertCodeMutation = { __typename?: 'Mutation', sendAlertCode: { __typename?: 'AlertRecipientSettingModel', user_id?: string | null, account_id?: string | null, email_enabled: boolean, email_status?: string | null, email_destination?: string | null, sms_enabled: boolean, sms_status?: string | null, sms_destination?: string | null } };

export type VerifyAlertCodeMutationVariables = Types.Exact<{
  input: Types.VerifyAlertSettingCodeInput;
}>;


export type VerifyAlertCodeMutation = { __typename?: 'Mutation', verifyAlertCode: { __typename?: 'AlertRecipientSettingModel', user_id?: string | null, account_id?: string | null, email_enabled: boolean, email_status?: string | null, email_destination?: string | null, sms_enabled: boolean, sms_status?: string | null, sms_destination?: string | null } };

export const AlertRecipientSettingModelFieldsFragmentDoc = gql`
    fragment AlertRecipientSettingModelFields on AlertRecipientSettingModel {
  user_id
  account_id
  email_enabled
  email_status
  email_destination
  sms_enabled
  sms_status
  sms_destination
}
    `;
export const ListAlertRecipientSettingsDocument = gql`
    query listAlertRecipientSettings($input: ListAlertRecipientSettingsInput!) {
  listAlertRecipientSettings(input: $input) {
    user_id
    account_id
    user {
      user_id
      first_name
      last_name
    }
    account {
      account_id
      account_name
    }
  }
}
    `;
export function useListAlertRecipientSettingsQuery(baseOptions: Apollo.QueryHookOptions<ListAlertRecipientSettingsQuery, ListAlertRecipientSettingsQueryVariables> & ({ variables: ListAlertRecipientSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAlertRecipientSettingsQuery, ListAlertRecipientSettingsQueryVariables>(ListAlertRecipientSettingsDocument, options);
      }
export function useListAlertRecipientSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAlertRecipientSettingsQuery, ListAlertRecipientSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAlertRecipientSettingsQuery, ListAlertRecipientSettingsQueryVariables>(ListAlertRecipientSettingsDocument, options);
        }
// @ts-ignore
export function useListAlertRecipientSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListAlertRecipientSettingsQuery, ListAlertRecipientSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<ListAlertRecipientSettingsQuery, ListAlertRecipientSettingsQueryVariables>;
export function useListAlertRecipientSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAlertRecipientSettingsQuery, ListAlertRecipientSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<ListAlertRecipientSettingsQuery | undefined, ListAlertRecipientSettingsQueryVariables>;
export function useListAlertRecipientSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAlertRecipientSettingsQuery, ListAlertRecipientSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAlertRecipientSettingsQuery, ListAlertRecipientSettingsQueryVariables>(ListAlertRecipientSettingsDocument, options);
        }
export type ListAlertRecipientSettingsQueryHookResult = ReturnType<typeof useListAlertRecipientSettingsQuery>;
export type ListAlertRecipientSettingsLazyQueryHookResult = ReturnType<typeof useListAlertRecipientSettingsLazyQuery>;
export type ListAlertRecipientSettingsSuspenseQueryHookResult = ReturnType<typeof useListAlertRecipientSettingsSuspenseQuery>;
export type ListAlertRecipientSettingsQueryResult = Apollo.QueryResult<ListAlertRecipientSettingsQuery, ListAlertRecipientSettingsQueryVariables>;
export const GetAlertRecipientSettingDocument = gql`
    query getAlertRecipientSetting($input: GetAlertRecipientSettingInput!) {
  getAlertRecipientSetting(input: $input) {
    ...AlertRecipientSettingModelFields
  }
}
    ${AlertRecipientSettingModelFieldsFragmentDoc}`;
export function useGetAlertRecipientSettingQuery(baseOptions: Apollo.QueryHookOptions<GetAlertRecipientSettingQuery, GetAlertRecipientSettingQueryVariables> & ({ variables: GetAlertRecipientSettingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAlertRecipientSettingQuery, GetAlertRecipientSettingQueryVariables>(GetAlertRecipientSettingDocument, options);
      }
export function useGetAlertRecipientSettingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAlertRecipientSettingQuery, GetAlertRecipientSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAlertRecipientSettingQuery, GetAlertRecipientSettingQueryVariables>(GetAlertRecipientSettingDocument, options);
        }
// @ts-ignore
export function useGetAlertRecipientSettingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAlertRecipientSettingQuery, GetAlertRecipientSettingQueryVariables>): Apollo.UseSuspenseQueryResult<GetAlertRecipientSettingQuery, GetAlertRecipientSettingQueryVariables>;
export function useGetAlertRecipientSettingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAlertRecipientSettingQuery, GetAlertRecipientSettingQueryVariables>): Apollo.UseSuspenseQueryResult<GetAlertRecipientSettingQuery | undefined, GetAlertRecipientSettingQueryVariables>;
export function useGetAlertRecipientSettingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAlertRecipientSettingQuery, GetAlertRecipientSettingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAlertRecipientSettingQuery, GetAlertRecipientSettingQueryVariables>(GetAlertRecipientSettingDocument, options);
        }
export type GetAlertRecipientSettingQueryHookResult = ReturnType<typeof useGetAlertRecipientSettingQuery>;
export type GetAlertRecipientSettingLazyQueryHookResult = ReturnType<typeof useGetAlertRecipientSettingLazyQuery>;
export type GetAlertRecipientSettingSuspenseQueryHookResult = ReturnType<typeof useGetAlertRecipientSettingSuspenseQuery>;
export type GetAlertRecipientSettingQueryResult = Apollo.QueryResult<GetAlertRecipientSettingQuery, GetAlertRecipientSettingQueryVariables>;
export const UpdateAlertRecipientSettingDocument = gql`
    mutation updateAlertRecipientSetting($input: UpdateAlertRecipientSettingInput!) {
  updateAlertRecipientSetting(input: $input) {
    ...AlertRecipientSettingModelFields
  }
}
    ${AlertRecipientSettingModelFieldsFragmentDoc}`;
export type UpdateAlertRecipientSettingMutationFn = Apollo.MutationFunction<UpdateAlertRecipientSettingMutation, UpdateAlertRecipientSettingMutationVariables>;
export function useUpdateAlertRecipientSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAlertRecipientSettingMutation, UpdateAlertRecipientSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAlertRecipientSettingMutation, UpdateAlertRecipientSettingMutationVariables>(UpdateAlertRecipientSettingDocument, options);
      }
export type UpdateAlertRecipientSettingMutationHookResult = ReturnType<typeof useUpdateAlertRecipientSettingMutation>;
export type UpdateAlertRecipientSettingMutationResult = Apollo.MutationResult<UpdateAlertRecipientSettingMutation>;
export type UpdateAlertRecipientSettingMutationOptions = Apollo.BaseMutationOptions<UpdateAlertRecipientSettingMutation, UpdateAlertRecipientSettingMutationVariables>;
export const SendAlertCodeDocument = gql`
    mutation sendAlertCode($input: SendAlertSettingCodeInput!) {
  sendAlertCode(input: $input) {
    ...AlertRecipientSettingModelFields
  }
}
    ${AlertRecipientSettingModelFieldsFragmentDoc}`;
export type SendAlertCodeMutationFn = Apollo.MutationFunction<SendAlertCodeMutation, SendAlertCodeMutationVariables>;
export function useSendAlertCodeMutation(baseOptions?: Apollo.MutationHookOptions<SendAlertCodeMutation, SendAlertCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendAlertCodeMutation, SendAlertCodeMutationVariables>(SendAlertCodeDocument, options);
      }
export type SendAlertCodeMutationHookResult = ReturnType<typeof useSendAlertCodeMutation>;
export type SendAlertCodeMutationResult = Apollo.MutationResult<SendAlertCodeMutation>;
export type SendAlertCodeMutationOptions = Apollo.BaseMutationOptions<SendAlertCodeMutation, SendAlertCodeMutationVariables>;
export const VerifyAlertCodeDocument = gql`
    mutation verifyAlertCode($input: VerifyAlertSettingCodeInput!) {
  verifyAlertCode(input: $input) {
    ...AlertRecipientSettingModelFields
  }
}
    ${AlertRecipientSettingModelFieldsFragmentDoc}`;
export type VerifyAlertCodeMutationFn = Apollo.MutationFunction<VerifyAlertCodeMutation, VerifyAlertCodeMutationVariables>;
export function useVerifyAlertCodeMutation(baseOptions?: Apollo.MutationHookOptions<VerifyAlertCodeMutation, VerifyAlertCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyAlertCodeMutation, VerifyAlertCodeMutationVariables>(VerifyAlertCodeDocument, options);
      }
export type VerifyAlertCodeMutationHookResult = ReturnType<typeof useVerifyAlertCodeMutation>;
export type VerifyAlertCodeMutationResult = Apollo.MutationResult<VerifyAlertCodeMutation>;
export type VerifyAlertCodeMutationOptions = Apollo.BaseMutationOptions<VerifyAlertCodeMutation, VerifyAlertCodeMutationVariables>;
import { withMutationResponseHandler, withQueryResponseHandler } from '../hooks/useResponseHandler';
export const useListAlertRecipientSettings = withQueryResponseHandler(useListAlertRecipientSettingsQuery);
export const useGetAlertRecipientSetting = withQueryResponseHandler(useGetAlertRecipientSettingQuery);
export const useUpdateAlertRecipientSetting = withMutationResponseHandler(useUpdateAlertRecipientSettingMutation, "updateAlertRecipientSetting");
export const useSendAlertCode = withMutationResponseHandler(useSendAlertCodeMutation, "sendAlertCode");
export const useVerifyAlertCode = withMutationResponseHandler(useVerifyAlertCodeMutation, "verifyAlertCode");